import { IDENT_METHOD_DOOR, IDENT_METHOD_STORE, IDENT_METHOD_VIDEO } from './constants';

const getIdentUi = (method, ui) => {
  const uiMapping = {
    door: {
      value: IDENT_METHOD_DOOR,
      label: ui.identMethodDoor,
      hint: ui.identMethodDoorHint,
    },
    store: {
      value: IDENT_METHOD_STORE,
      label: ui.identMethodStore,
      hint: ui.identMethodStoreHint,
    },
    video: {
      value: IDENT_METHOD_VIDEO,
      label: ui.identMethodVideo,
      hint: ui.identMethodVideoHint,
    },
  };
  return uiMapping[method];
};
/**
 * @param {Object[][]} countries
 * @param {String[]} includedIdentMethods
 * @returns {*}
 */
export const filterCountriesByIdentMethods = function (countries, includedIdentMethods) {
  if (!countries || countries.length === 0) {
    return [];
  }
  return countries.map((country) => {
    const newCountry = { ...country };
    newCountry.identMethods = country.identMethods.filter(
      (method) => includedIdentMethods.includes(method.name),
    );
    return newCountry;
  });
};
/**
 * Returns the ident methods for preferred ident methods and a given nationality.
 * E. g. ['store', 'video']
 * @param nationality A given nationality
 * @param countries The existing countries
 * @param {String[]} preferredMethods The preferred ident methods
 * @return {Array} The Possible ident methods for the given nationality
 */
export const getIdentMethods = function (nationality, countries, preferredMethods = []) {
  if (!countries || countries.length === 0 || !nationality) {
    return [];
  }
  const filteredCountries = filterCountriesByIdentMethods(countries, preferredMethods);
  return filteredCountries.find(country =>
    country.id.toUpperCase() === nationality.toUpperCase()).identMethods;
};
/**
 * Maps the ui elements to the given ident methods and filters non viable options
 * @param methods The given ident methods
 * @param ui
 * @param pplus If true sorts out all identity media that dooesn't support pplus
 * @return {Array} The ident methods
 */
export const getIdentOptions = function (methods, ui, pplus = false) {
  return methods
    .map(method => ({
      ...method,
      // filter identity media that doesn't support pplus only if flag is set
      availableIdentityMedia: method.availableIdentityMedia.filter(element =>
        !pplus || element.pPlus,
      ),
      ...getIdentUi(method.name, ui),
    }))
    // filter elements that are empty after the pplus filter
    .filter(f => !pplus || f.availableIdentityMedia
      .find(e => e.pPlus),
    );
};
